var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon",class:[{ spin: _vm.spin }, _vm.sizeClass],domProps:{"innerHTML":_vm._s(_vm.svgContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }